import React, { useEffect, useState } from "react";
import "./ReEnterPasswordModal.css";
import ClipLoader from "react-spinners/ClipLoader";

const ReEnterPasswordModal = ({ isOpen, onConfirm, onCancel, loading }) => {
  const [password, setPassword] = useState("");

  if (!isOpen) return null;

  const handleSubmit = () => {
    onConfirm(password);
    setPassword("");
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content text-left modal-content_">
        <input type="password" name="fakepass" style={{ display: "none" }} />
        <h5>Confirm your identity</h5>
        <input
          type="password"
          name="password"
          autoComplete="new-password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div className="modal-actions">
          <button
            onClick={handleSubmit}
            className={loading === true ? "btn-disabled mr-2" : "save-btn mr-2"}
            disabled={loading === true ? true : false}
          >
            {loading === true ? <ClipLoader size={25} color="grey" /> : "Save"}
          </button>
          <button onClick={onCancel} className="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReEnterPasswordModal;
